{
  "16d2a82fd6e5b96f": "Shift Information",
  "175a2747a35d5e64": "Shift Start: {{shiftStartTime}}",
  "19c73a5cdf346d96": "Professional",
  "247a45c3415e9336": "No Information",
  "2d8cbda0cc14afb6": "ETA: {{etaTime}}",
  "383b084da568040f": "Our estimate: {{etaTime}} arrival",
  "3fba2c78314f1915": "Type: {{shiftQualification}}",
  "42b42fa1ddc8ef9a": "Estimated Time of Arrival",
  "460b3a7da007b7af": "Chat",
  "4e952b41752d7990": "Live Worker ETA",
  "63eb561dbf27be58": "Hide on Map",
  "6e032f5357f0e998": "{{etaTime}} arrival",
  "6fc3b01a3743e0bb": "No upcoming shifts",
  "7371031c223e1545": "Show on Map",
  "82eab215405dc397": "Updated {{updatedAt}}",
  "9b64e6f7d70b02b0": "{{workerName}} has not left for their shift yet",
  "9e86fb3406204da6": "Show all on Map",
  "c71c7bd6882ad7c9": "Arrived at {{arrivedTime}}",
  "e97aa9177af0106d": "Worker reported: {{workerDeclaredEta}} arrival",
  "ff8059dc6752afdd": "Actions"
}
